import { useEffect, useRef } from 'react';
import cn from 'classnames';
import { TextField } from 'seagull';
import { isValidHexColor } from "../../business-logic/colorsLogic";
import { ColorSelector } from "../ColorSelector/ColorSelector";
import styles from "./ColorPicker.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Renders a text input for HEX values with a preview on the right for the color,
 * which is also a native color picker when clicked.
 */
export function ColorPicker(props) {
  const {
    color,
    className,
    testid,
    selected,
    displayColor,
    onChange,
    onBlur
  } = props;
  const colorInputRef = useRef(null);
  const isValidColor = isValidHexColor(color);
  useEffect(() => {
    if (onBlur && colorInputRef.current) {
      const inputEl = colorInputRef.current;
      inputEl.addEventListener('change', onBlur);
      return () => {
        inputEl.removeEventListener('change', onBlur);
      };
    }
  }, [onBlur]);
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.root, className),
    children: [/*#__PURE__*/_jsx(TextField, {
      collapseHelperText: false,
      size: "small",
      prefix: "#",
      label: "Customize color",
      testid: testid && "".concat(testid, "-text"),
      value: color.slice(1),
      error: !isValidColor,
      helperText: isValidColor ? '' : '3 or 6 valid digits please',
      onChange: function (_onChange) {
        function onChange(_x) {
          return _onChange.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange.toString();
        };
        return onChange;
      }(e => onChange("#".concat(e.target.value))),
      onBlur: onBlur
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.previewWrapper,
      children: [/*#__PURE__*/_jsx(ColorSelector, {
        withBorder: true,
        hasError: !isValidColor,
        selected: selected,
        color: displayColor || 'linear-gradient(180deg, #EB3563 0%, #6564F6 51.56%, #84F96B 100%)',
        onClick: () => {
          var _colorInputRef$curren;
          return (_colorInputRef$curren = colorInputRef.current) === null || _colorInputRef$curren === void 0 ? void 0 : _colorInputRef$curren.click();
        }
      }), /*#__PURE__*/_jsx("input", {
        ref: colorInputRef,
        className: styles.input,
        type: "color",
        value: color,
        onChange: function (_onChange2) {
          function onChange(_x2) {
            return _onChange2.apply(this, arguments);
          }
          onChange.toString = function () {
            return _onChange2.toString();
          };
          return onChange;
        }(e => onChange(e.target.value))
      })]
    })]
  });
}